module.exports = __webpack_public_path__ + "img/hr-express-splitter-south.ca40746e.png";